import template from './filter-input.template.html';
import DebouncedToggle from '../../../../components/debounced-toggle';

class FilterInputController extends DebouncedToggle {
	constructor($timeout) {
		'ngInject';

		super($timeout);

		this.toggle = false;
	}

	$onInit() {}

	toggleDropdown() {
		this.toggle = !this.toggle;
	}

	optionClicked(option) {
		this.toggleDropdown();
		this.update({ item: option });
		this.searchTerm = undefined;
	}

	removeOption(option) {
		this.toggleDropdown();
		this.remove({ item: option });
		this.searchTerm = undefined;
	}

	pushAndSortBy(array, item) {
		array.push(item);
		return _.sortBy(array, 'label');
	}

	closeDropdown() {
		this._debounceToggle()
			.then(() => (this.toggle = false))
			.catch(this._ignore);
	}

	shouldShowBadge() {
		return !this.toggle && this.selected && this.selected.length > 0;
	}

	hasSingleValue(selectedOption) {
		const { selectedValues } = selectedOption;
		return !!selectedValues && selectedValues.length === 1;
	}

	hasMultipleValues(selectedOption) {
		const { selectedValues } = selectedOption;
		return !!selectedValues && selectedValues.length > 1;
	}

	isAny(selectedOption) {
		const { anyValue, selectedValues } = selectedOption;
		return anyValue && (!selectedValues || selectedValues.length === 0);
	}

	isRange(selectedOption) {
		const { selectedRange } = selectedOption;
		return !!selectedRange && (selectedRange.min || selectedRange.max);
	}

	getSelectedRangeType(selectedOption) {
		const { selectedRange } = selectedOption;
		if (selectedRange.min && selectedRange.max) {
			return 'min-max';
		} else if (selectedRange.min && !selectedRange.max) {
			return 'min';
		} else {
			return 'max';
		}
	}

	renderMinMax(selectedOption) {
		const { selectedRange } = selectedOption;
		if (typeof selectedRange.min === 'string' || typeof selectedRange.max === 'string') {
			const min = moment(selectedRange.min);
			const max = moment(selectedRange.max);
			return `${min.format('L')} - ${max.format('L')}`;
		}
		return `${selectedRange.min} - ${selectedRange.max}`;
	}

	renderMin(selectedOption) {
		const { selectedRange } = selectedOption;
		if (typeof selectedRange.min === 'string') {
			const min = moment(selectedRange.min);
			return `> ${min.format('L')}`;
		}
		return `> ${selectedRange.min}`;
	}

	renderMax(selectedOption) {
		const { selectedRange } = selectedOption;
		if (typeof selectedRange.max === 'string') {
			const max = moment(selectedRange.max);
			return `< ${max.format('L')}`;
		}
		return `< ${selectedRange.max}`;
	}

	isSelected(option) {
		return _.find(this.selected, 'key', option.key) != null;
	}
}

export const FilterInputComponent = {
	template,
	controller: FilterInputController,
	controllerAs: 'vm',
	bindings: {
		label: '@',
		options: '<',
		selected: '<',
		update: '&',
		remove: '&'
	}
};
